export function elementFromString(str: string): Element | null {
    const clipboard = document.createElement('div');

    clipboard.innerHTML = str.trim();

    return <Element | null>clipboard.firstElementChild;
}
